import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import crypto from './../crypto/cryptoencrypt'
import store from './../store'


const instanct = axios.create({
    baseURL: 'https://culture.aqitai.com/',
    timeout: 100000,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    transformRequest: [data => qs.stringify(data)]
})


instanct.interceptors.request.use((req) => {

    req.headers.Authorization = 'Bearer ' + ((localStorage.token) ? (localStorage.token) : '')
    if(req.method=='get'){
        if(req.params){
            req.params.library_id = localStorage.getItem('libId')?localStorage.getItem('libId'):''
            req.params.manuscript_class_idcom = localStorage.getItem('gjType')?localStorage.getItem('gjType'):''
            req.params.users_id = localStorage.getItem('userInfoMemberId')?localStorage.getItem('userInfoMemberId'):''
            req.params.users_type = localStorage.getItem('user_type')?localStorage.getItem('user_type'):''
        }else {
            let keyVal ={
                library_id:localStorage.getItem('libId')?localStorage.getItem('libId'):'',
                manuscript_class_idcom:localStorage.getItem('gjType')?localStorage.getItem('gjType'):'',
                users_id:localStorage.getItem('userInfoMemberId')?localStorage.getItem('userInfoMemberId'):'',
                users_type:localStorage.getItem('user_type')?localStorage.getItem('user_type'):'',
            }
            Vue.prototype.$set(req,'params',keyVal)
        }
        req.params = crypto.set(req.params,'qwsdefghyjygrfed')

    }else if(req.method=='post'){
        if(req.data){
            req.data.library_id = localStorage.getItem('libId')?localStorage.getItem('libId'):''
            req.data.manuscript_class_idcom = localStorage.getItem('gjType')?localStorage.getItem('gjType'):''
            req.data.users_id = localStorage.getItem('userInfoMemberId')?localStorage.getItem('userInfoMemberId'):''
            req.data.users_type = localStorage.getItem('user_type')?localStorage.getItem('user_type'):''
        }else {
            let keyVal ={
                library_id:localStorage.getItem('libId')?localStorage.getItem('libId'):'',
                manuscript_class_idcom:localStorage.getItem('gjType')?localStorage.getItem('gjType'):'',
                users_id:localStorage.getItem('userInfoMemberId')?localStorage.getItem('userInfoMemberId'):'',
                users_type:localStorage.getItem('user_type')?localStorage.getItem('user_type'):'',
            }
            Vue.prototype.$set(req,'data',keyVal)
        }
        req.data = crypto.set(req.data,'qwsdefghyjygrfed')
    }
    return req

}, error => {
    return Promise.reject(error)
})


instanct.interceptors.response.use((res) => {
    let mainData = Object.assign({}, res.data)
    if (mainData.code === 200) {
        let nns = crypto.get(mainData.data,'aqitaibookwebasd')
        let resdata = Object.assign({}, nns)
        if (resdata.current_page) {
            delete resdata.data
        }
        return {
            data: resdata.current_page ? nns.data : nns,
            code: mainData.code,
            message: mainData.message,
            pages: resdata.current_page ? resdata : null
        }
    } else {
        handleErr(mainData)
        return Promise.reject({
            'code': mainData.code,
            'message': mainData.message
        })
    }
}, res => {
    if (res.response.status === 401) {
         Vm.$router.push({path:'/login',query:{lib:Vm.$route.query.lib,alis:Vm.$route.query.alis}})
        Vm.$clearLocalStorageExceptActivePages()
        sessionStorage.clear()
        Vm.$store.state.tabList = '[]'
        Vm.$store.state.userInfo = ''

    } else {
        if (!res.response) {
            handleErr({
                code: '请求无响应！',
                message: res.config.url
            })
            return false
        }
    }

    return Promise.reject(res)
})

function handleErr(data) {
    if (data.code == 403) {
        Vue.prototype.$RecordNum++ //判断近义词页面只走一次登录判断接口
        if (Vue.prototype.$RecordNum == 1) {
            Vm.$Notice.error({
                title: '登录超时',
                desc: '请重新登录'
            })
            setTimeout(() => {
                 Vm.$router.push({path:'/login',query:{lib:Vm.$route.query.lib,alis:Vm.$route.query.alis}})
                Vm.$clearLocalStorageExceptActivePages()
                sessionStorage.clear()
		Vm.$store.state.tabList = '[]'
		Vm.$store.state.userInfo = ''
            }, 1000)
            return false
        }

    } else if(data.code == 300){
        Vm.$Message.error(data.message.mn)
    }else {
        Vm.$Message.error(data.message)
    }
}

export default instanct
